module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAw4AAAACAQMAAADLphnoAAAABlBMVEXk4+MqKSmwInczAAAAAnRSTlPtnor0/toAAAAQSURBVAjXY/hPa/CHgfYAAKMJYZz8CdQaAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/pagess/gdd116/h2-2.png
// module id = m8pu
// module chunks = 1